module.exports = __webpack_public_path__ + "static/media/person-dolly.8591930f.svg";